import templateUrl from "emun.report/powerbi-list.htm";
import controller from "emun.report/powerbi-list.controller";

export default {
  templateUrl,
  bindings: {
  },
  controller
};
